import { render, staticRenderFns } from "./PurPL_List.vue?vue&type=template&id=27411a59"
import script from "./PurPL_List.vue?vue&type=script&lang=js"
export * from "./PurPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports